import React from 'react';
import { Linkedin } from 'lucide-react';
import { useModal } from './ModalContext';
import { Button } from './Button';
export const Footer = () => {
  const {
    openSignupModal
  } = useModal();
  return <footer className="relative w-full overflow-hidden bg-primary-800 py-20 text-white" data-id="element-69" data-mp="32oniuyfytg6u">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-700 to-primary-900" data-id="element-70" data-mp="36oy1baky1z2l" />
      <div className="absolute -right-40 -top-40 h-[500px] w-[500px] rounded-full bg-blue-500/10 blur-3xl" data-id="element-71" data-mp="3ufa64ckw7foy" />

      <div className="container relative mx-auto px-6" data-id="element-72" data-mp="398y6cw8527j">
        <div className="mb-14 grid grid-cols-1 gap-10 md:grid-cols-12" data-id="element-73" data-mp="36ms6hozeurf">
          <div className="md:col-span-4" data-id="element-74" data-mp="3ldu52vfywpxe">
            <a href="/" className="mb-5 block" aria-label="Nisa home" data-id="element-75" data-mp="3qdf2v2jeis8j">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jP7ueorRtM9x7giMYpBsys/nisa-capriola-logotype.png" alt="Nisa" className="h-8 w-auto brightness-0 invert" data-id="element-76" data-mp="3qblyjtw9gk3p" />
            </a>
            <a href="https://www.linkedin.com/company/nisacoach/" target="_blank" rel="noopener noreferrer" className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-white/10 transition-colors hover:bg-white/20" aria-label="Follow Nisa on LinkedIn" data-id="element-77" data-mp="2ezl2rv0zbveg">
              <Linkedin className="h-5 w-5 fill-current" strokeWidth={0} data-id="element-78" data-mp="3v8rhjvky59ya" />
            </a>
          </div>

          <div className="md:col-span-2" data-id="element-79" data-mp="3q7lqs3aujwre">
            <h3 className="mb-4 font-medium text-white" data-id="element-80" data-mp="3qazrz87rxzx9">Product</h3>
            <ul className="space-y-3" data-id="element-81" data-mp="81fojswysm2m">
              <li data-id="element-82" data-mp="33xe1y3atysi">
                <a href="/#the-problem" className="font-medium text-cyan-100 transition-colors hover:text-white" data-id="element-83" data-mp="34gvzesy8n6j">
                  Why Nisa
                </a>
              </li>
              <li data-id="element-84" data-mp="ctqo2unsm5un">
                <a href="/#features" className="font-medium text-cyan-100 transition-colors hover:text-white" data-id="element-85" data-mp="ct76xg5yvlho">
                  For coaches
                </a>
              </li>
              <li data-id="element-86" data-mp="mrwqrehfbg0k">
                <a href="/#for-teachers" className="font-medium text-cyan-100 transition-colors hover:text-white" data-id="element-87" data-mp="msg74qrfdwch">
                  For teachers
                </a>
              </li>
              <li data-id="element-88" data-mp="yty0xuoj2v56">
                <a href="/schools" className="font-medium text-cyan-100 transition-colors hover:text-white" data-id="element-89" data-mp="ytei8br202q3">
                  Schools
                </a>
              </li>
              <li data-id="element-90" data-mp="18k0sdqg0411e">
                <a href="/#proof" className="font-medium text-cyan-100 transition-colors hover:text-white" data-id="element-91" data-mp="18kiyrfwdnvn1">
                  Trust by design
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2" data-id="element-92" data-mp="1hjw53zp7g43j">
            <h3 className="mb-4 font-medium text-white" data-id="element-93" data-mp="1hms6jy09hawq">Company</h3>
            <ul className="space-y-3" data-id="element-94" data-mp="1ml3gs9ugxnfh">
              <li data-id="element-95" data-mp="1mhxqira3sfi6">
                <a href="/about" className="font-medium text-cyan-100 transition-colors hover:text-white" data-id="element-96" data-mp="1rildn1v7oc74">
                  About Us
                </a>
              </li>
              <li data-id="element-97" data-mp="3od86deohw8n1">
                <a href="/security" className="font-medium text-cyan-100 transition-colors hover:text-white" data-id="element-98" data-mp="3ta86za2ksj6r">
                  Security
                </a>
              </li>
              <li data-id="element-99" data-mp="2ah87722jtky5">
                <a href="/privacy" className="font-medium text-cyan-100 transition-colors hover:text-white" data-id="element-100" data-mp="25of2ufazseml">
                  Privacy
                </a>
              </li>
              <li data-id="element-101" data-mp="21n1xe6btadg7">
                <a href="/terms" className="font-medium text-cyan-100 transition-colors hover:text-white" data-id="element-102" data-mp="1wnp87exgwuag">
                  Terms
                </a>
              </li>
              <li data-id="element-103" data-mp="2td6mujefhqoa">
                <a href="/sub-processors" className="font-medium text-cyan-100 transition-colors hover:text-white" data-id="element-104" data-mp="2tbn66rov1dlz">
                  Sub-processors
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4" data-id="element-105" data-mp="2fegpd2np5oze">
            <h3 className="mb-4 font-medium text-white" data-id="element-106" data-mp="2fdf2m0xbje1u">Stay connected</h3>
            <p className="mb-4 text-cyan-100" data-id="element-107" data-mp="18yeg0lu6o87x">
              Get thoughtful updates from Nisa.
            </p>
            <Button variant="outline" size="sm" onClick={openSignupModal} className="border-white/30 text-cyan-50 transition-all hover:bg-white/10" data-id="element-108" data-mp="13y058w176k67">
              Stay in the loop
            </Button>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-cyan-700 pt-8 md:flex-row" data-id="element-109" data-mp="2wnr3sxg5gz76">
          <p className="text-sm font-medium text-gray-300" data-id="element-110" data-mp="2it85oy78ohuo">
            © {new Date().getFullYear()} Nisa. All rights reserved.
          </p>
          <div className="flex items-center gap-2" data-id="element-111" data-mp="3bjgtb5kjnugn">
            <span className="text-sm font-medium text-gray-300" data-id="element-112" data-mp="3bhvxlcmhu5h7">Powered by</span>
            <a href="https://www.teachinglabstudio.com/" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-cyan-200 transition-colors hover:text-white" data-id="element-113" data-mp="3fkitbomacajo">
              Teaching Lab Studio
            </a>
          </div>
        </div>
      </div>
    </footer>;
};